import React from 'react';

import { DossierDtoAdminFonctionnel } from 'lib_api/lib/api/gen';

import UpdateDonneesVehicule from 'components/UpdateDonneesVehicule/UpdateDonneesVehicule';
import { useApi } from 'hooks/ApiStoreContext';
import { useDossierAdminContext } from 'hooks/dossierAdmin/DossierAdminContext';
import { useDossierCompletAdmin } from 'hooks/dossierAdmin/useDownloadDossierCompletAdminFonctionnel';

import 'components/UpdateDonneesVehicule/UpdateDonneesVehicule.less';

interface UpdateDonneesVehiculeProps {
  closeModal: () => void;
}

function UpdateDonneesVehiculeAdminFonctionnel({
  closeModal,
}: UpdateDonneesVehiculeProps): React.ReactElement {
  const [{ result, setDossier: setDossierHook }, { fetchEvents }] =
    useDossierAdminContext();
  const dossierId = result.id;
  const {
    dossier: dossierAdmin,
    fetchInProgress,
    fetchDossier,
    errorOccured,
  } = useDossierCompletAdmin(dossierId);
  const {
    AdminFonctionnelControllerApi: adminController,
    ReferentielControllerApi: refController,
  } = useApi();

  async function setDossier(dossier: DossierDtoAdminFonctionnel) {
    setDossierHook(dossier);
    await fetchEvents();
  }

  return (
    <UpdateDonneesVehicule
      closeModal={closeModal}
      controller={adminController}
      dossierId={dossierId}
      refController={refController}
      setDossier={setDossier}
      fetchInProgress={fetchInProgress}
      fetchDossier={fetchDossier}
      errorOccured={errorOccured}
      dossierBody={dossierAdmin?.dossier.body}
    />
  );
}

export default UpdateDonneesVehiculeAdminFonctionnel;
